import { useCallback } from "react";
import { useDispatch } from "react-redux"
import API from "service/API";
import { setGrowthOverview, setIcbOverview, setIcbOverviewV4, setOverview } from "store/actionReducers/AStore";

export default function useA() {
  const dispatch = useDispatch();

  const fetchOverview = useCallback(async (code: any) => {
    const res = await API.A.getOverview({ code: code })
    if (res?.code === '0') {
      
      const icbcode = res?.data?.icbcode
      const icbcodeLv4 = res?.data?.icbcodeLv4
      if (icbcode) {
        fetchIcbOverview(icbcode)
        fetchIcbOverviewV4(icbcodeLv4)
      }
      dispatch(setOverview(res?.data))
    }
  }, [])

  const fetchIcbOverview = useCallback(async (code: any) => {
    const res = await API.A.getIcbOverview({ code: code })
    if (res?.code === '0') {
      dispatch(setIcbOverview(res?.data))
    }
  }, [])

  const fetchIcbOverviewV4 = useCallback(async (code: any) => {
    const res = await API.A.getIcbOverview({ code: code })
    
    if (res?.code === '0') {
      dispatch(setIcbOverviewV4(res?.data))
    }
  }, [])
  
  const compareDataOverview = useCallback((Overview, IcbOverview) => {
    let pe = '0'
    if (Overview?.pe) {
      pe = typeof Overview?.pe === 'string' ? parseFloat(Overview?.pe).toFixed(2) : Overview?.pe.toFixed(2)
    }
    let peicb = '0'
    if (IcbOverview?.pe) {
      peicb = typeof IcbOverview?.pe === 'string' ? parseFloat(IcbOverview?.pe).toFixed(2) : IcbOverview?.pe.toFixed(2)
    }
    let pb = '0'
    if (Overview?.pe) {
      pb = typeof Overview?.pb === 'string' ? parseFloat(Overview?.pb).toFixed(2) : Overview?.pb.toFixed(2)
    }
    let pbicb = '0'
    if (IcbOverview?.pb) {
      pbicb = typeof IcbOverview?.pb === 'string' ? parseFloat(IcbOverview?.pb).toFixed(2) : IcbOverview?.pb.toFixed(2)
    }
    let dividenYield = '0'
    if (Overview?.dividenYield) {
      dividenYield = typeof Overview?.dividenYield === 'string' ? parseFloat(Overview?.dividenYield).toFixed(2) : Overview?.dividenYield.toFixed(2)
    }
    let dividenYieldicb = '0'
    if (IcbOverview?.dividenYield) {
      dividenYieldicb = typeof IcbOverview?.dividenYield === 'string' ? parseFloat(IcbOverview?.dividenYield).toFixed(2) : IcbOverview?.dividenYield.toFixed(2)
    }
    let evEbitda = '0'
    if (Overview?.evEbitda) {
      evEbitda = typeof Overview?.evEbitda === 'string' ? parseFloat(Overview?.evEbitda).toFixed(2) : Overview?.evEbitda.toFixed(2)
    }
    let evEbitdaicb = '0'
    if (IcbOverview?.evEbitda) {
      evEbitdaicb = typeof IcbOverview?.evEbitda === 'string' ? parseFloat(IcbOverview?.evEbitda).toFixed(2) : IcbOverview?.evEbitda.toFixed(2)
    }

    const dataNew: any = {
      pe: BothValueOverview(pe, peicb),
      pe_value: [pe, peicb],
      pb: BothValueOverview(pb, pbicb),
      pb_value: [pb, pbicb],
      dividenYield: BothValueOverview(dividenYield, dividenYieldicb),
      dividenYield_value: [dividenYield, dividenYieldicb],
      evEbitda: BothValueOverview(evEbitda, evEbitdaicb),
      evEbitda_value: [evEbitda, evEbitdaicb],
      eps: Overview?.eps ? parseFloat(Overview?.eps).toFixed(2) : 0,
      peg: Overview?.peg ? parseFloat(Overview?.peg).toFixed(2) : 0,
    }
    return dataNew;
  }, [])

  const BothValueOverview = (value1: string, value2: string) => {
    const valueNumber1 = value1 ? parseFloat(value1.toString()) : 0
    const valueNumber2 = value2 ? parseFloat(value2.toString()) : 0

    let data: any = []
    if (valueNumber1 > valueNumber2) {
      data[0] = 100
      data[1] = (valueNumber2 / valueNumber1) * 100
    } else {
      data[0] = (valueNumber1 / valueNumber2) * 100
      data[1] = 100
    }
    return data
  }

  const getGrowthOverview = useCallback(async (stock) => {
    if (stock) {
      const res = await API.Growth.getGrowthOverview(stock)

      if (res?.code === '0') {
        dispatch(setGrowthOverview(res?.data))
      }
    }
  }, [])

  const compareDataGrowthOverview = useCallback((Overview) => {
    let netsale = '0'
    if (Overview?.netsale) {
      netsale = Overview?.netsale ? Overview?.netsale.toFixed(2) : '';
    }
    let netsale_icb = '0';
    if (Overview?.icb_netsale) {
      netsale_icb = Overview?.icb_netsale ? Overview?.icb_netsale.toFixed(2) : '';
    }
    let net_profit = '0';
    if (Overview?.net_profit) {
      net_profit = Overview?.net_profit ? Overview?.net_profit.toFixed(2) : '';
    }
    let net_profit_icb = '0';
    if (Overview?.icb_net_profit) {
      net_profit_icb = Overview?.icb_net_profit ? Overview?.icb_net_profit.toFixed(2) : '';
    }
    let equity = '0';
    if (Overview?.equity) {
      equity = Overview?.equity ? Overview?.equity.toFixed(2) : '';
    }
    let equity_icb = '0';
    if (Overview?.icb_equity) {
      equity_icb = Overview?.icb_equity ? Overview?.icb_equity.toFixed(2) : '';
    }

    const dataNew = {
      net_profit: BothValueOverview(net_profit, net_profit_icb),
      net_profit_value: [net_profit, net_profit_icb],
      netsale: BothValueOverview(netsale, netsale_icb),
      netsale_value: [netsale, netsale_icb],
      equity: BothValueOverview(equity, equity_icb),
      equity_value: [equity, equity_icb],
      gross_profit: Overview?.gross_profit,
      profit_before_tax: Overview?.profit_before_tax,
      eps: Overview?.eps
    }

    return dataNew;
  }, [])

  const valueMathZero = useCallback((value) => {
    let valueNew = 0
    if (typeof value === 'string') {
      valueNew = parseFloat(value)
    } else {
      valueNew = value
    }
    let color = ''
    if (valueNew === 0) {
      color = '#ffd900'
    } else if (valueNew > 0) {
      color = '#2ad03d'
    } else if (valueNew < 0) {
      color = '#e31e4d'
    }
    
    return color;
  }, [])

  return {
    fetchOverview,
    fetchIcbOverview,
    compareDataOverview,
    getGrowthOverview,
    compareDataGrowthOverview,
    BothValueOverview,
    valueMathZero
  }
}